import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, DatePicker, Form, Input, message, Row, Select, Modal} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import AutoOpenSelect from '../../SelectComponent/AutoOpenSelect';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
//import initialTermsCondition from '../../../Common/intialTermsCondition';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAlloysList, resetAlloyList } from '../../../slices/alloy';
import { fetchTempersList, resetCurrentTemperPage, resetTempersList } from '../../../slices/tempers';
import { fetchjobWorkList, resetJobWorkList } from '../../../slices/job-work';
import { fetchInquiryQuotationById, updateInquiryQuotation, deleteInquiryDetailById } from '../../../slices/inquiry-quotation';

const { Option } = Select;

export default function EditInquiryQuotation() {
  const [form] = Form.useForm();
  const { id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [editorValue, setEditorValue] = useState('');

  const { loading } = useSelector(state => state.inquiryQuotation);
  const { list: alloyDropdown, loading: alloyLoading } = useSelector(state => state.alloy);
  const { list: temperDropDown, loading: temperLoading } = useSelector(state => state.temper);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);

  useEffect(() => {
    dispatch(resetAlloyList());
    dispatch(resetTempersList());
    dispatch(resetCurrentTemperPage());
    dispatch(resetJobWorkList());
    dispatch(fetchAlloysList({ page: 1, pagesize: 1000 }));
    dispatch(fetchTempersList({ page: 1, pagesize: 1000 }))
    dispatch(fetchjobWorkList());
  }, [dispatch]);

  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        const response = await dispatch(fetchInquiryQuotationById(id)).unwrap();
        if (response) {

          const quotationDetails = response?.data?.inquiry_quotation_details?.length > 0 ? response?.data?.inquiry_quotation_details.map(detail => ({
            id: detail?.id || null,
            section_no: detail.section_no,
            alloy: detail.alloy,
            temper: detail.temper,
            length: detail.length || null,
            price_per_kg: detail?.price_per_kg || '',
            quantity: detail?.quantity || '',
            conversion: detail?.conversion,
            packing_cost: detail?.packing_cost,
             surface_finish: detail?.surface_finish,
            cutting: detail.cutting,
            cutting_price: detail?.cutting_price,
            machining: detail.machining || false,
            machining_price: detail?.machining_price,
            deburring: detail.deburring || false,
            deburring_price: detail.deburring_price || undefined,
            anodising: detail.anodising || false,
             anodising_description: detail.anodising_description || undefined,
            anodising_price: detail.anodising_price || undefined,
            powder_coating: detail.powder_coating || false,
            powder_coating_description: detail.powder_coating_description || undefined,
            powder_coating_price: detail.powder_coating_price || undefined,
            pvdf: detail.pvdf || false,
            pvdf_description: detail.pvdf_description || undefined,
            pvdf_price: detail.pvdf_price || undefined,
          }))
            : [];

            
          form.setFieldsValue({
            customer_name: response?.data?.customer_name || null,
            quotation_date: response?.data?.quotation_date ? dayjs(response?.data?.quotation_date) : null,
            remarks: response?.data?.remarks || null,
            terms_and_condition: response?.data?.terms_and_condition,
            quotation_details: quotationDetails,
          });

          setEditorValue(
            response?.terms_and_condition,
          );

        }
      } catch (error) {
        console.error('Error fetching quotation:', error);
        message.error('Failed to load quotation data.');
      }
    };

    fetchQuotation();
  }, [id, form, dispatch]);

  useEffect(() => {
    if (form.getFieldValue('terms_and_condition')) {
      setEditorValue(form.getFieldValue('terms_and_condition'));
    }
  }, [form.getFieldValue('terms_and_condition')]);

  const handleChange = content => {
    setEditorValue(content);
    form.setFieldsValue({ terms_and_condition: content });
  };

  const handleFinish = values => {
    const formattedQuotationDate = dayjs(values.quotation_date).format('YYYY-MM-DD');
    const transformedQuotationDetails = values.quotation_details.map(detail => {
      const basicDetail = {
        id: detail?.id || null,
        section_no: detail.section_no,
        alloy: detail.alloy,
        temper: detail.temper,
        length: detail.length || null,
        price_per_kg: detail.price_per_kg || '',
        quantity: detail?.quantity || '',
        conversion: detail?.conversion,
        packing_cost: detail?.packing_cost,
        surface_finish: detail.surface_finish || '',
        cutting: detail.cutting || false,
        machinings: detail.machinings || false,
        deburring: detail.deburring || false,
        cutting_price: detail.cutting_price || undefined,
        machining_price: detail.machining_price || undefined,
        deburring_price: detail.deburring_price || undefined,
        anodising: detail.anodising || false,
        anodising_description: detail.anodising_description || undefined,
        anodising_price: detail.anodising_price || undefined,
        powder_coating: detail.powder_coating || false,
        powder_coating_description: detail.powder_coating_description || undefined,
        powder_coating_price: detail.powder_coating_price || undefined,
        pvdf: detail.pvdf || false,
        pvdf_description: detail.pvdf_description || undefined,
        pvdf_price: detail.pvdf_price || undefined,
      };

      return basicDetail;
    });

    const payload = {
      customer_name: values.customer_name,
      quotation_date: formattedQuotationDate,
      quotation_details: transformedQuotationDetails,
      terms_and_condition: values.terms_and_condition,
      remarks: values.remarks,
    };
    dispatch(updateInquiryQuotation({id: id, values: payload}))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Quotation Updated Successfully!');
          navigate('/inquiry-quotation-list');
        }
      })
      .catch(error => {

        let displayMessage = '';
        if (typeof error === 'object') {
          displayMessage = Object.entries(error)
            .map(([key, value]) => `${key}: ${value.join(', ')}`)
            .join('\n');
          message.error(displayMessage);
        } else {
          message.error(`Error: ${error || 'Failed to update the quotation.'}`);
        }
      });
  };


  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Edit Inquiry Quotation</h2>
          <div className="bredcrumbwrp">
            <Link
              className="back"
              onClick={() => {
                navigate(-1);
              }}
            >
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/inquiry-quotation-list">Quotation List</Link> },
                { title: 'Edit Inquiry Quotation' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          autoComplete="off"
        >
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="customer_name"
                  label="Customer Name"
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <Input placeholder="Enter Customer Name" readOnly/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="quotation_date"
                  label="Quotation Date"
                  rules={[
                    { required: true, message: 'Please select quotation date' },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    style={{ width: '100%' }}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Edit Item</h3>
            <Form.List name="quotation_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%', flexWrap: 'nowrap' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'section_no']}
                              label="Section Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select profile number',
                                },
                              ]}
                            >
                              <Input placeholder='Enter Section Number' readOnly/>
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                disabled
                                allowClear
                                showSearch={true}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {alloyDropdown.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.name} - {el.color_code}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Temper"
                                loading={temperLoading}
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                disabled
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {temperDropDown.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.name} - {el.code}
                                  </Option>
                                ))}
                                {temperLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length (mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter length',
                                }
                              ]}
                            >
                              <Input
                                placeholder="0" readOnly

                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'price_per_kg']}
                              label="Price per kg"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Price per kg',
                                },

                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'quantity']}
                              label="Quantity (Kg)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Quantity kg',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'packing_cost']}
                              label="Packing Cost"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'surface_finish']}
                              label="Surface finish"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select jobwork',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Jobwork"
                                mode="multiple"
                                value={form.getFieldValue([
                                  'quotation_details',
                                  name,
                                  'jobworks',
                                ])}
                                allowClear
                                disabled
                                showSearch
                                optionFilterProp="children"
                                onChange={value => {
                                  form.setFieldValue(
                                    ['quotation_details', name, 'jobworks'],
                                    value,
                                  );
                                }}
                                loading={jobWorkLoading}
                              >
                                {jobWorkLoading ? (
                                  <Option key="loading" disabled>
                                    Loading...
                                  </Option>
                                ) : (
                                  jobWorkdata?.map(item => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))
                                )}
                              </AutoOpenSelect>

                            </Form.Item>
                          </Col>

                           <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.quotation_details?.[index]?.surface_finish !==
                              currentValues.quotation_details?.[index]?.surface_finish
                            }
                            noStyle
                          >
                            {({ getFieldValue }) => {
                              const selectedSurfaceFinish = getFieldValue(["quotation_details", index, "surface_finish"]) || [];
 
                              const selectedItems = jobWorkdata?.filter(item => selectedSurfaceFinish.includes(item.id));

                           
                              // Example: show conditional field if Laser Marking selected
                              const hasEngineering = selectedItems.some(item => item.name === "Engineering");
                              const hasSurfaceTreatment = selectedItems.some(item => item.name === "Surface treatment");

                              return (
                                <>
                                  {/* --- Engineering Fields --- */}
                                  {hasEngineering && (
                                    <>
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.quotation_details?.[index]?.cutting !== curr.quotation_details?.[index]?.cutting ||
                                          prev.quotation_details?.[index]?.machining !== curr.quotation_details?.[index]?.machining ||
                                          prev.quotation_details?.[index]?.deburring !== curr.quotation_details?.[index]?.deburring
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const cutting = getFieldValue(['quotation_details', index, 'cutting']);
                                          const machining = getFieldValue(['quotation_details', index, 'machining']);
                                          const deburring = getFieldValue(['quotation_details', index, 'deburring']);

                                          return (
                                            <>
                                              {cutting && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Cutting Price"
                                                    name={[name, 'cutting_price']}
                                                    rules={[{ required: true, message: 'Enter Cutting Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {machining && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Machining Price"
                                                    name={[name, 'machining_price']}
                                                    rules={[{ required: true, message: 'Enter Machining Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {deburring && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Deburring Price"
                                                    name={[name, 'deburring_price']}
                                                    rules={[{ required: true, message: 'Enter Deburring Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                  {/* --- Surface Treatment Fields --- */}
                                  {hasSurfaceTreatment && (
                                    <>


                                      {/* Nested conditional price fields */}
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.quotation_details?.[index]?.anodising !== curr.quotation_details?.[index]?.anodising ||
                                          prev.quotation_details?.[index]?.powder_coating !== curr.quotation_details?.[index]?.powder_coating ||
                                          prev.quotation_details?.[index]?.pvdf !== curr.quotation_details?.[index]?.pvdf
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const anodising = getFieldValue(["quotation_details", index, "anodising"]);
                                          const powder_coating = getFieldValue(["quotation_details", index, "powder_coating"]);
                                          const pvdf = getFieldValue(["quotation_details", index, "pvdf"]);
                                          return (
                                            <>
                                              {anodising && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Anodising Price"
                                                    name={[name, "anodising_price"]}
                                                    rules={[{ required: true, message: "Enter Anodising Price" }]}
                                                  >
                                                    <Input placeholder="Enter Anodising Price" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {powder_coating && (
                                                <Col xs={12} md={8} xl={3}>

                                                  <Form.Item
                                                    label="Powder Coating Price"
                                                    name={[name, "powder_coating_price"]}
                                                    rules={[{ required: true, message: "Enter Powder Coating Price" }]}
                                                  >
                                                    <Input placeholder="Enter Powder Coating Price" />
                                                  </Form.Item>

                                                </Col>
                                              )}

                                              {pvdf && (
                                                <Col xs={12} md={8} xl={3}>

                                                  <Form.Item
                                                    label="PVDF Description"
                                                    name={[name, "pvdf_price"]}
                                                    rules={[{ required: true, message: "Enter PVDF Price" }]}
                                                  >
                                                    <Input placeholder="Enter PVDF Price" />
                                                  </Form.Item>

                                                </Col>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          </Form.Item>

                        </Row>
                      </Col>
                      <Col>
                        <div className="addwrp">
                          {form.getFieldValue("quotation_details").length !== 1 && (
                            <Button
                              type="primary"
                              danger
                              icon={<MinusCircleOutlined />}
                               onClick={() => {
                                    const currentDetails = form.getFieldValue("quotation_details") || [];
                                    const currentItem = currentDetails[index];

                                    if (currentItem?.id) {

                                      Modal.confirm({
                                        title: "Are you sure you want to delete this item?",
                                        content: "This will permanently remove this inquiry detail.",
                                        okText: "Yes, Delete",
                                        cancelText: "Cancel",
                                        okButtonProps: { danger: true },
                                        async onOk() {
                                          try {
                                            message.loading({ content: "Deleting...", key: "deleteDetail" });
                                            await dispatch(deleteInquiryDetailById(currentItem.id)).unwrap();
                                            message.success({ content: "Inquiry detail deleted", key: "deleteDetail" });

                                            // Remove from form after successful deletion
                                            remove(name);
                                          } catch (error) {
                                            message.error({ content: "Failed to delete inquiry detail", key: "deleteDetail" });
                                          }
                                        },
                                      });
                                    } else {
                                      // 🔹 Just remove locally if not saved
                                      remove(name);
                                    }
                                  }}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '30px',
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                  ))}
                  {/* <Form.Item>
                    <div className="w-100 flex justify-end ">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            add({ price_per_kg: 0 });
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item> */}
                </>
              )}
            </Form.List>
          </div>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                name="terms_and_condition"
                label="Terms & Condition"
                rules={[
                  { required: true, message: 'Terms & Condition is required' },
                ]}
                valuePropName="content"
              >
                <ReactQuill
                  value={editorValue}
                  onChange={handleChange}
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: '1' }, { header: '2' }, { font: [] }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['bold', 'italic', 'underline'],
                      [{ align: [] }],
                      ['link', 'image'],
                      ['blockquote', 'code-block'],
                    ],
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="remarks" label="Remarks">
                <Input.TextArea
                  placeholder="Enter Remarks"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ remarks: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={loading}
            >
              Edit Quotation
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
